import { useQuery, useQueryClient } from '@tanstack/react-query';

import { me } from '@/features/auth/api/auth-api';
import type { CandidateRecord } from '@/lib/api/schemas';

import { fetchLookups } from './api/application-api';

export const meKey = ['me'] as const;
export const lookupsKey = ['lookups'] as const;

export function useMe() {
  return useQuery({ queryKey: meKey, queryFn: me });
}

export function useLookups() {
  return useQuery({ queryKey: lookupsKey, queryFn: () => fetchLookups(), staleTime: Infinity });
}

export function useSetMe() {
  const qc = useQueryClient();
  return (record: CandidateRecord) => qc.setQueryData(meKey, record);
}
